import {
  api
} from '@/api'
import router from '@/router'
import Layout from '@/components/layout'
const _import = require('../../router/_import_' + process.env.NODE_ENV)
const state = {
  promptData: '',
  isFirst: true,
  isAuth: false,
  isShowPrompt: false, // 是否显示到期提醒
  routes: [],
  logo: 'http://longbingcdn.xiaochengxucms.com/admin/diy/default.png',
  isFreeAuth: -1,
  diyID: 0,
  diyKey: 0
}
const getters = {
  isAuth: state => {
    return state.isAuth
  },
  routes: state => {
    return state.routes
  },
  logo: state => {
    return state.logo
  },
  isFreeAuth: state => {
    return state.isFreeAuth
  },
  diyID: state => {
    return state.diyID
  },
  diyKey: state => {
    return state.diyKey
  }
}
const mutations = {
  // 修改到期提醒数据
  changePromptData (state, data) {
    if (data.status === 2) {
      state.isShowPrompt = true
    } else if (data.status === 1 && state.isFirst) {
      state.isFirst = false
      state.isShowPrompt = true
    }
    state.promptData = data
  },
  // 修改是否显示到期提醒
  changeIsShowPrompt (state, item) {
    state.isShowPrompt = item
  },
  saveItem (state, obj) {
    let {key, val} = obj
    state[key] = val
  },
  saveRoutes (state, routes = []) {
    state.routes = routes
    state.isAuth = true
  }
}
const actions = {
  changeItem ({
    commit
  }, obj) {
    commit('saveItem', obj)
  },
  getUserPromission ({
    commit
  }, obj) {
    api.getRoutes().then(res => {
      if (res.code === 200) {
        // console.log(res.data, '路由')
        let allRoutes = [...res.data, {
          path: '*',
          redirect: '/404',
          hidden: true
        }]
        commit('saveRoutes', allRoutes)
        routerGo(allRoutes, obj)
      }
    })
    if (process.env.NODE_ENV === 'development') {
      commit('saveRoutes', obj.routes)
      routerGo(obj.routes, obj)
    } else {
      // 正式请求接口获取路由
      api.getRoutes().then(res => {
        if (res.code === 200) {
          // console.log(res.data, '路由')
          let allRoutes = [...res.data, {
            path: '*',
            redirect: '/404',
            hidden: true
          }]
          commit('saveRoutes', allRoutes)
          routerGo(allRoutes, obj)
        }
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}

function routerGo (routes, obj) {
  let getRouter = filterAsyncRouter(routes) // 过滤路由
  router.options.routes.push(...getRouter)
  router.addRoutes(getRouter) // 动态添加路由
  // localStorage.setItem('routes', JSON.stringify(getRouter))
  obj.next({ ...obj.to,
    replace: true
  })
}

function filterAsyncRouter (asyncRouterMap) { // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Layout') { // Layout组件特殊处理
        route.component = Layout
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
  return accessedRouters
}

// function getRouteChildre (routes, name) {
//   let routeObj = ''
//   for (let i = 0, len = routes.length; i < len; i++) {
//     if (routes[i].path === name) {
//       routeObj = routes[i]
//       break
//     }
//   }
//   return routeObj
// }



// WEBPACK FOOTER //
// ./src/store/modules/routes.js